import {useState} from "react";
import BarChart from "./charts/BarChart";
import {DashboardBarChartDataMapType, DashboardSettingListElementType} from "../../interface";
import DraggableCard from "../drag/DraggableCard";

interface Props {
    title: string
    titleKeyword: string,
    data: DashboardBarChartDataMapType
    item: DashboardSettingListElementType
}

export default function BarChartCard({title, titleKeyword, data, item}: Props) {
    const [view, setView] = useState<number>(1)

    const btnView = (i: number) => {
        setView(i)
    }

    return <DraggableCard order={item.dashboardInfoId} item={item}>
        {({dragHandleRef}) =>
            <div className="content_wrap h-295px">
                <div className="fiter_top align-items-start mb-0">
                    <h3 className="filter_heading icon2 clickable" ref={dragHandleRef}>
                        <span>{titleKeyword}</span>{title}</h3>
                    <div className="filter_toolbar">
                        <button className="btn btn-primary color2 px-0 w-60px" onClick={() => btnView(1)}>이관</button>
                        <button className="btn btn-info px-0 color2 w-60px" onClick={() => btnView(2)}>마감</button>
                    </div>
                </div>
                <div className="chart_outer">
                    <BarChart
                        title={`${titleKeyword}${title}`}
                        paramData={data}
                        view={view}
                    />
                </div>
            </div>
        }
    </DraggableCard>
}